import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MenuItem, MessageService} from 'primeng/api';
import {finalize} from 'rxjs/operators';
import {EngineStructureService} from '@tj/tj-dmp-lib-api';

@Component({
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class MaintenanceComponent {
    breadcrumb: MenuItem[] = [
        {label: this.translate.instant('menu.admin.label')},
        {label: 'Maintenance', routerLink: '/h/admin/maintenance'},
    ];
    description = 'Permet de lancer des actions de maintenance.' as const;

    isUpdatingTriggers = false;

    constructor(
        private readonly messageService: MessageService,
        private readonly translate: TranslateService,
        private readonly engineStructure: EngineStructureService,
    ) {
    }

    onUpdateTriggers(): void {
        this.isUpdatingTriggers = true;

        this.engineStructure.checkVersioningTriggers()
            .pipe(finalize(() => (this.isUpdatingTriggers = false)))
            .subscribe({
                next: () => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Succès',
                        detail: 'Mise à jour des triggers effectuée avec succès.',
                    });
                },
                error: () => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: 'Un problème est survenu pendant la mise à jour des triggers.',
                    });
                },
            });
    }
}
